export default "__VITE_ASSET__5Fy0Bl1t__"